import React from "react";
import styled from "styled-components";
import Header from "@components/Header";
import GlobalStyle from "@styles/GlobalStyle";
import Head from "@components/Head";
import UserContext from "@contexts/user";
import logo from "../../images/jt_logo_new.png";

const StyledLayout = styled.div`
  // max-width: ${({ theme }) => theme.maxWidth.page};
  margin: 0 auto;
`;

const Wrapper = styled.div``;
const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;
`;

const Logo = styled.img`
  @media (max-width: 767px) {
    height: 18px;
  }
  @media (min-width: 768px) {
    height: 25px;
  }
  margin: 0;
`;

const Layout = ({
  // head,
  children,
  // current,
  // fixedNavbar,
  // withoutFooter,
  ...props
}) => {
  return (
    <StyledLayout {...props}>
      <Head />
      <GlobalStyle />
      <Header />
      <UserContext.Consumer>
        {user => (
          <Wrapper>
            <LogoWrapper>
              <Logo src={logo} alt={"정토회 예약시스템"} />
            </LogoWrapper>
            {children}
          </Wrapper>
        )}
      </UserContext.Consumer>
    </StyledLayout>
  );
};

export default Layout;
